var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStartup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-89 1 511 511.99975",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 21.3736605004,
    x2: 238.2851639006,
    xlinkHref: "#a",
    y1: 415.6050852274,
    y2: 479.40262166
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3862,
    stopColor: "#8c9db6",
    stopOpacity: 0.384314
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    stopColor: "#7a899a",
    stopOpacity: 0.772549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 237.7063024754,
    x2: 171.073288746,
    xlinkHref: "#c",
    y1: 485.5769427444,
    y2: 313.3237048078
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 54.7145124736,
    x2: 129.6540772232,
    xlinkHref: "#e",
    y1: 294.8135917562,
    y2: 351.9104507998
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 311.7600064522,
    x2: 200.7962066156,
    xlinkHref: "#e",
    y1: 281.255524754,
    y2: 333.2148129626
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 58.8577989598,
    x2: 318.754732595,
    xlinkHref: "#a",
    y1: 189.5661237876,
    y2: 189.5661237876
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 261.614504121,
    x2: 87.8884122182,
    xlinkHref: "#c",
    y1: 262.0267039426,
    y2: 88.3006120398
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 119.7712682708,
    x2: 186.0659602862,
    xlinkHref: "#j",
    y1: 120.1833677002,
    y2: 186.4781601078
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 422.964126 374.780838)",
    gradientUnits: "userSpaceOnUse",
    x1: 223.189,
    x2: 267.8757,
    xlinkHref: "#j",
    y1: 174.7833,
    y2: 219.47
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 143.6966369826,
    x2: 176.382028282,
    xlinkHref: "#m",
    y1: 144.108736412,
    y2: 176.7941277114
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 233.1339397264,
    x2: 98.123798577,
    xlinkHref: "#c",
    y1: 359.8222596896,
    y2: 224.812018148
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 119.7712682708,
    x2: 186.0659602862,
    xlinkHref: "#j",
    y1: 246.4606925482,
    y2: 312.7553845636
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 422.964126 374.780838)",
    gradientUnits: "userSpaceOnUse",
    x1: 223.189,
    x2: 267.8757,
    xlinkHref: "#j",
    y1: 48.9993,
    y2: 93.6861
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 143.6966369826,
    x2: 176.382028282,
    xlinkHref: "#m",
    y1: 270.38606126,
    y2: 303.0714525594
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 60.053570454,
    x2: 188.4146358052,
    xlinkHref: "#e",
    y1: -39.181820777,
    y2: 89.1792445742
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 41.6373241094,
    x2: 270.5572405126,
    xlinkHref: "#e",
    y1: 390.612748214,
    y2: 390.612748214
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 166.964236,
    x2: 166.964236,
    xlinkHref: "#c",
    y1: 496.405044652,
    y2: 520.5063004982
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.683594 512h280.5625c8.367187 0 13.980468-8.625 10.566406-16.269531-6.191406-13.855469-19.582031-23.789063-35.421875-25.050781.015625-.402344.03125-.804688.03125-1.210938 0-16.585938-13.441406-30.03125-30.027344-30.03125-7.289062 0-13.972656 2.597656-19.171875 6.917969-4.855468 4.03125-10.855468 6.433593-17.167968 6.433593h-.609376c-8.714843.015626-15.785156-7.042968-15.785156-15.753906v-64.324218h-65.390625v64.324218c0 8.710938-7.070312 15.769532-15.785156 15.753906h-.609375c-6.3125 0-12.3125-2.402343-17.167969-6.433593-5.199219-4.320313-11.882812-6.917969-19.171875-6.917969-16.585937 0-30.027344 13.445312-30.027344 30.03125 0 .40625.011719.808594.03125 1.210938-15.839843 1.261718-29.230468 11.195312-35.421874 25.050781-3.417969 7.644531 2.195312 16.269531 10.566406 16.269531zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m317.8125 495.730469c-6.191406-13.855469-19.582031-23.789063-35.421875-25.050781.015625-.402344.03125-.804688.03125-1.210938 0-16.585938-13.441406-30.03125-30.027344-30.03125-7.289062 0-13.972656 2.597656-19.171875 6.917969-4.855468 4.03125-10.855468 6.433593-17.167968 6.433593h-.609376c-8.714843.015626-15.785156-7.042968-15.785156-15.753906v-64.328125h-65.390625v42.445313l96.847657 96.847656h76.128906c8.367187 0 13.980468-8.625 10.566406-16.269531zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m111.761719 392.09375h-94.710938c-9.140625 0-16.550781-8.28125-16.550781-18.5v-58.601562c0-5.683594 2.335938-11.046876 6.332031-14.554688l104.929688-92.027344zm0 0",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m222.167969 392.09375h94.710937c9.140625 0 16.550782-8.28125 16.550782-18.5v-58.601562c0-5.683594-2.335938-11.046876-6.335938-14.554688l-104.925781-92.027344zm0 0",
    fill: "url(#g)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m254.980469 379.132812h-176.03125v-232.300781c0-50.832031 20.773437-99.457031 57.507812-134.589843 17.0625-16.324219 43.949219-16.324219 61.011719 0 36.734375 35.132812 57.511719 83.757812 57.511719 134.589843zm0 0",
    fill: "url(#h)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m254.980469 189.164062-53.492188-53.492187c-8.570312-9.324219-20.863281-15.171875-34.523437-15.171875-25.890625 0-46.878906 20.988281-46.878906 46.875 0 13.664062 5.847656 25.957031 15.175781 34.527344l119.71875 119.71875zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 120.5c-25.890625 0-46.878906 20.988281-46.878906 46.875 0 25.890625 20.988281 46.878906 46.878906 46.878906 25.886718 0 46.878906-20.988281 46.878906-46.878906 0-25.886719-20.992188-46.875-46.878906-46.875zm0 0",
    fill: "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 199.097656c17.519531 0 31.722656-14.203125 31.722656-31.722656s-14.203125-31.722656-31.722656-31.722656c-17.519532 0-31.722656 14.203125-31.722656 31.722656s14.203124 31.722656 31.722656 31.722656zm0 0",
    fill: "url(#l)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 144.265625c-12.765625 0-23.113282 10.347656-23.113282 23.109375 0 12.765625 10.347657 23.113281 23.113282 23.113281 12.761718 0 23.113281-10.347656 23.113281-23.113281 0-12.761719-10.351563-23.109375-23.113281-23.109375zm0 0",
    fill: "url(#n)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m254.980469 315.445312v63.6875h-68.769531l-50.953126-50.953124c-9.324218-8.574219-15.171874-20.867188-15.171874-34.527344 0-25.886719 20.988281-46.878906 46.878906-46.878906 13.660156 0 25.953125 5.855468 34.527344 15.171874zm0 0",
    fill: "url(#o)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 246.777344c-25.890625 0-46.878906 20.988281-46.878906 46.875 0 25.890625 20.988281 46.878906 46.878906 46.878906 25.886718 0 46.878906-20.988281 46.878906-46.878906 0-25.886719-20.992188-46.875-46.878906-46.875zm0 0",
    fill: "url(#p)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 325.375c17.519531 0 31.722656-14.203125 31.722656-31.722656 0-17.519532-14.203125-31.722656-31.722656-31.722656-17.519532 0-31.722656 14.203124-31.722656 31.722656 0 17.519531 14.203124 31.722656 31.722656 31.722656zm0 0",
    fill: "url(#q)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m166.964844 270.542969c-12.765625 0-23.113282 10.347656-23.113282 23.109375 0 12.765625 10.347657 23.113281 23.113282 23.113281 12.761718 0 23.113281-10.347656 23.113281-23.113281 0-12.761719-10.351563-23.109375-23.113281-23.109375zm0 0",
    fill: "url(#r)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m197.46875 12.242188c-17.0625-16.324219-43.949219-16.324219-61.011719 0-19.703125 18.847656-34.8125 41.578124-44.589843 66.449218 22.539062 4.917969 48.058593 7.691406 75.097656 7.691406 27.035156 0 52.554687-2.773437 75.09375-7.691406-9.777344-24.871094-24.882813-47.601562-44.589844-66.449218zm0 0",
    fill: "url(#s)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m78.949219 365.738281v41.171875c0 4.738282 3.839843 8.578125 8.574219 8.578125h158.878906c4.738281 0 8.578125-3.839843 8.578125-8.578125v-41.171875zm0 0",
    fill: "url(#t)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m16.113281 495.730469c-3.414062 7.644531 2.199219 16.269531 10.570313 16.269531h280.5625c8.367187 0 13.980468-8.625 10.566406-16.269531-2.96875-6.648438-7.609375-12.375-13.367188-16.695313h-274.960937c-5.761719 4.320313-10.398437 10.046875-13.371094 16.695313zm0 0",
    fill: "url(#u)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStartup);
export default __webpack_public_path__ + "static/media/icon-startup.a102a3f9a1a74530deec7da2c0fc6b8c.svg";
export { ForwardRef as ReactComponent };